<hr>
  @if (isLoading$ | async) {
    <div>
      <div class="cx-spinner">
        <cx-spinner> </cx-spinner>
      </div>
    </div>
  } @else {
    @if (!isRestricted) {
      <div class="fast-entry-container">
        <p class="fast-entry-title">{{ 'fastEntry.title' | cxTranslate }}</p>
        <p>{{ 'fastEntry.hint' | cxTranslate }}</p>
        <form [formGroup]="fastEntryForm" (ngSubmit)="onSubmit()" autocomplete="off">
          @for (entry of fastEntryForm.get('entries')['controls']; track entry; let i = $index) {
            <ng-container formArrayName="entries"
              >
              <div class="form-group row" [formGroupName]="i">
                <div class="col-md-4">
                  <input
                    type="text"
                    [id]="'code_' + i"
                    class="form-control code"
                    name="code"
                    placeholder="{{ 'fastEntry.placeholders.articleNo' | cxTranslate }}"
                    formControlName="code"
                    (input)="addOnChange(i)"
                    />
                  </div>
                  <div class="col-md-2">
                    <input
                      type="text"
                      [id]="'quantity_' + i"
                      class="form-control quantity"
                      name="quantity"
                      placeholder="{{ 'fastEntry.placeholders.quantity' | cxTranslate }}"
                      formControlName="quantity"
                      (input)="addOnChange(i)"
                      />
                    </div>
                    <div class="col-md-6">
                      <input
                        type="text"
                        [id]="'note_' + i"
                        class="form-control text-right"
                        name="note"
                        placeholder="{{ 'fastEntry.placeholders.note' | cxTranslate }}"
                        formControlName="note"
                        (input)="addOnChange(i)"
                        />
                      </div>
                    </div>
                  </ng-container>
                }
                <div class="form-group row fast-entry-action">
                  <div class="col-md-4">
                    <button class="btn btn-secondary btn-block mb-6" type="submit">
                      {{ 'fastEntry.buttons.submit' | cxTranslate }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          }
        }
        <hr>
